import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { productsAppliesWhenMenuItems } from './constants'

const AppliesWhenSelector = ({ value, onChange, disabled, menuItems = productsAppliesWhenMenuItems }) => {
  const { t } = useTranslation()

  const translatedMenuItems = menuItems.map(item => ({ value: item.value, label: t(item.label) }))

  const handleChange = e => onChange(e.target.value)

  return (
    <ComboBox
      label={t('Se aplica cuando')}
      menuItems={translatedMenuItems}
      handleChange={handleChange}
      value={value || ''}
      fullWidth
      disabled={disabled}
    />
  )
}

export default AppliesWhenSelector
